export { default } from './GlobalDayDetail';
